import ContractDetails from './ContractDetails'

export default ContractDetails
